import { eManulSortLayerDrawOrder, eSfxSprite, Game } from "../../../Game";
import { Ball } from "../../Player/Ball";
import { RoundManager } from "../../Round/RoundManager";
import { ePhysicsObjects } from "../../Stadium/Stadium";
import { eCornerTargetPos } from "../Controllers/CornerController";
import { TargetManager } from "../TargetManager";
import { TargetType } from "../TargetType";
import { eTargetState, TargetBase } from "./Target";



export class CornerTarget extends TargetBase {
    private static readonly RADIUS = 1;

    /**
     * Prevod eCornerTargetPos na index rotace terce
     */
    private static readonly POS_TO_ROT = [0, 3, 1, 2];

    private _originPos: eCornerTargetPos;
    private _tmpVec2 = new pc.Vec2();

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(mng: TargetManager, type: TargetType) {
        super(mng, type);

        // Detekce kolize
        this._entity.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.box,
            halfExtents: [CornerTarget.RADIUS / 2, 0.1, CornerTarget.RADIUS / 2]
        });
        this._entity.collision.on("triggerenter", this.handleTriggerEnter, this);

        // Nasobeni skore
        this._scoreMultiplier = 1;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci true, pokud je pravdepodobne, ze vykopnuty mic zasahne terc
     * @param ballGoalTime 
     * @param ballGoalPos 
     * @returns 
     */
    //-------------------------------------------------------------------------
    checkKickOffResult(ballGoalTime: number, ballGoalPos: pc.Vec2): boolean {
        let pos = this._tmpVec2.copy(this.getPositionInTime(ballGoalTime));

        this.targetPosToTargetCenterPos(pos);

        return (Math.sqrt(Math.pow(ballGoalPos.x - pos.x, 2) + Math.pow(pos.y - ballGoalPos.y, 2)) <= CornerTarget.RADIUS + Ball.RADIUS);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    setOriginPos(pos: eCornerTargetPos): void {
        if (RoundManager.instance.roundSetup.flippedHorizontally) {
            if ((pos += 2) >= 4)
                pos -= 4;
        }

        this._originPos = pos;
        this._entity.setEulerAngles(90, 0, -CornerTarget.POS_TO_ROT[pos] * 90);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected init(): void {
        // Rozmer
        this._width = this._height = CornerTarget.RADIUS;

        // Poradi vykreslovani terce
        this._entity.model.meshInstances[0].drawOrder = eManulSortLayerDrawOrder.target;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateScale(): void {
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateOpacity(): void {
    }

    //-------------------------------------------------------------------------
    /**
     * Prevede pozici terce na pozici je stredu
     * @param pos 
     */
    //-------------------------------------------------------------------------
    private targetPosToTargetCenterPos(pos: pc.Vec2 | pc.Vec3): void {
        pos.x -= this._width / 2;
        pos.y += this._height / 2;

        if ((this._originPos & 2) != 0)
            pos.x += this._width;

        if ((this._originPos & 1) != 0)
            pos.y -= this._height;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTriggerEnter(other: pc.Entity): void {
        if (other.name != ePhysicsObjects.ball || this._state != eTargetState.idle)
            return;

        let targetPos = this._entity.getPosition();
        let ballPos = other.getPosition();

        this.targetPosToTargetCenterPos(targetPos);
        let hitEntry = this.calculateHit(new pc.Vec2(targetPos.x, targetPos.y), new pc.Vec2(ballPos.x, ballPos.y), CornerTarget.RADIUS + Ball.RADIUS);

        if (!hitEntry)
            return;

        // Zobrazit animaci ulomku terce
        this._mng.activateShards(2, this);
        this._entity.enabled = false;

        // Zvuk
        Game.playSound(eSfxSprite.targetHit);

        // Animace zmizeni
        this.startHitAnim();

        // Predat udalost "triggerenter" mici
        other.collision.fire("triggerenter", this._entity);
    }
}